<template>
  <div>
    <PrivacyList :queryParams="queryParams" :fieldItems="fieldItems"/>
  </div>
</template>
<script>


import DatePicker from 'vue2-datepicker';

import PrivacyList from "./privacy/compoent/PrivacyList";
export default {
  name:'PrivacyManagement',
  components: {
    PrivacyList,
    DatePicker,
  },
  data() {
    return {
      fullDate: [],
      queryParams: {
        start_date: '',
        end_date: '',
        keyword: '',
      },
      fieldItems: [{
        'rnum': {
          'label': '번호',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'manager_id': {
          'label': '관리자 아이디',
          'class': 'text-center',
          'thStyle': {'vertical-align': 'middle'}
        }
      }, {
        'download_count': {
          'label': '다운로드수',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle',
            'text-align': 'center'
          }
        }
      }, {
        'download_date': {
          'label': '다운로드 일자',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'reason': {
          'label': '다운로드 사유',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'download_type_name': {
          'label': '다운로드 타입',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }],
    }
  },
  computed: {
    listRows() {
      return this.items.length
    }
  },
  mounted: function() {
  },
  methods: {

  }
}

</script>




// WEBPACK FOOTER //
// src/views/common/PrivacyManagement.vue